import * as React from 'react';
import { ToggleSwitch } from '@inmoment/the-kitchen';

type ToggleSwitchProps = Parameters<typeof ToggleSwitch>[0];

export interface Props {
  propName: string;
  defaultState?: boolean;
  onToggle: Required<ToggleSwitchProps>['onToggle'];
}

export const ToggleControl: React.VFC<Props> = (props) => {
  const { propName, onToggle, defaultState } = props;

  return (
    <ToggleSwitch label={propName} isToggled={defaultState} color="orca" onToggle={onToggle} isLabelInline={false} style={{ marginBottom: 18 }} />
  );
};
